export function hasDropzoneElement() {
    return document.querySelector('.dropzone') !== null;
}

export async function loadDropzone() {
    try {
        const DropzoneModule = await import('dropzone');
        const Dropzone = DropzoneModule.default;

        await import('dropzone/dist/dropzone.css');

        // Make Dropzone available globally
        window.Dropzone = Dropzone;

        return Dropzone;
    } catch (error) {
        console.error('Failed to load Dropzone:', error);
        return null;
    }
}

function initDropzone(selector, config, maxAttempts = 50) {
    if (window.Dropzone) {
        try {
            return new Dropzone(selector, config);
        } catch (error) {
            console.error('Error initializing Dropzone:', error);
            return null;
        }
    }

    if (maxAttempts <= 0) {
        console.error('Dropzone failed to load after maximum attempts');
        return null;
    }

    return setTimeout(() => {
        initDropzone(selector, config, maxAttempts - 1);
    }, 200);
}

// Make initDropzone available globally
window.initDropzone = initDropzone;

// Initialize Dropzone when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    if (hasDropzoneElement()) {
        loadDropzone().then(Dropzone => {
            if (Dropzone) {
                // console.log('Dropzone loaded and ready to use');
            }
        });
    }
});
